import { createFileRoute } from '@tanstack/react-router';

import { assertPermissionOrRedirect, Permission } from '@auth/data-access';
import { getSamplingQueries, SamplingPlansMapPage } from '@sampling';

export const Route = createFileRoute('/_app/_admin/sampling-plans-map')({
  beforeLoad(ctx) {
    assertPermissionOrRedirect(ctx.context.auth, Permission.WipPages);
  },
  loader: async ({ context }) => {
    const queries = getSamplingQueries();
    await context.queryClient.prefetchQuery(
      queries.plans.maps({
        page: 1,
        sorting: [],
        filters: [],
      }),
    );
    // Prefetch filters as well
    await context.queryClient.prefetchQuery(queries.orders.filters());
  },
  component: SamplingPlansMapPage,
});
